(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('FindLeadsDialogController', FindLeadsDialogController);

    function FindLeadsDialogController($mdDialog, $mdMedia, $q, $timeout, authentication, account, flagsService, leadsService, themeService, utils, model, $translate) {

        const vm = this;

        vm.model = model;

        vm.getTheme = function () {

            return themeService.get();
        };

        vm.$mdMedia = $mdMedia;
        vm.searchLeadsPlaceholder = $translate.instant('Search leads by role(s)');

        vm.creditsLeft = (model.me.team.credit_quota - model.me.team.credit_usage);
        vm.hasInsufficientCredits = () => vm.creditsLeft <= 0 || vm.leads.selectedAmount > vm.creditsLeft;

        // Const thread = null;
        // let accountObject;
        // const dirtyContacts = [];

        let insightsTour = null;

        vm.search = '';
        vm.contacts = [];
        vm.selectedContacts = [];
        vm.submitting = false;
        vm.jobTitles = [];
        vm.showCountInfoIcon = false;
        vm.creating = false;

        let foundLead = 0;

        vm.leads = {
            toLoad: 0,
            numLoaded: 0,
            items: [],
            topIndex: 0,
            stepAmount: 20,
            selectedAmount: 0,
            doneLoading: false,

            getItemAtIndex: function (index) {

                if (index > this.numLoaded) {
                    this.fetchMoreItems(index);

                    return null;
                }

                return this.items[index];
            },

            getLength: function () {

                if (this.items.length < this.numLoaded) {
                    return this.items.length;
                }

                return this.numLoaded + this.stepAmount;
            },

            fetchMoreItems: function (index) {

                if (this.toLoad < index) {
                    this.toLoad += this.stepAmount;

                    const boundResponseHandler = angular.bind(this, leadsResponse);

                    const options = {
                        jobTitles: vm.jobTitles.map((title) => title.name)
                    };

                    if (this.next_page_token) {
                        options.next_page_token = this.next_page_token;
                    }

                    return account.getLeads(vm.accountId, options).then(boundResponseHandler);
                }
            },

            // Forces reset of object
            reload: function () {

                this.toLoad = 0;
                // Keep selected leads when performing a new search
                this.items = this.items?.filter((item) => item.selected);
                this.numLoaded = this.items.length;
                this.selectedAmount = this.items.length;
                this.doneLoading = false;
                this.topIndex = 0;
                this.next_page_token = null;
            }
        };

        function leadsResponse(response) {

            if (response && response.data) {

                this.next_page_token = response.data.next_page_token;

                this.items = [...this.items, ...response.data.leads];
                this.numLoaded += this.stepAmount;

                if (response.data.count) {
                    foundLead = response.data.count;
                }

                this.doneLoading = true;
            }
            else {
                this.doneLoading = true;
            }
        }

        vm.$onInit = function () {

            if (flagsService.get('showLeadSearchWalkthrough') === true) {
                showWalkthrough();
            }
        };

        vm.onLeadSelect = () => {

            vm.leads.selectedAmount = vm.leads.items.filter((lead) => lead.selected).length;
        };

        vm.selectLead = (lead) => {
            lead.selected = true;
            vm.onLeadSelect();
        };

        vm.getEntityCountString = function () {

            // Out of credits entirely
            if (vm.creditsLeft <= 0) {
                return $translate.instant('You\'re out of lead credits. Please upgrade or purchase a package.');
            }

            // Selected more than available credits
            if (vm.leads.selectedAmount > vm.creditsLeft) {
                const creditsLabel = vm.creditsLeft === 1 ? $translate.instant('credit') : $translate.instant('credits');
                const leadsLabel = vm.leads.selectedAmount === 1 ? $translate.instant('lead') : $translate.instant('leads');
                return $translate.instant('You have') + ' ' + vm.creditsLeft + ' ' + creditsLabel + ' ' + $translate.instant('left and') + ' ' + vm.leads.selectedAmount + ' ' + leadsLabel + ' ' + $translate.instant('selected. Please upgrade or purchase a package.');
            }

            if (vm.leads.selectedAmount > 0) {
                vm.showCountInfoIcon = true;
                return vm.leads.selectedAmount + ' ' + $translate.instant('lead credit') + (vm.leads.selectedAmount > 1 ? 's' : '') + ' ' + $translate.instant('will be used');
            }

            vm.showCountInfoIcon = false;
            return foundLead + ' ' + $translate.instant('leads found');
        };

        vm.back = function () {

            return close();
        };

        vm.searchJobTitles = function (queryString) {

            if (!queryString || queryString === '') {
                return [];
            }

            return $q(function (resolve) {

                return leadsService.autocompleteLookup(queryString, 'job_titles').then(function (response) {

                    const jobTitles = response.data;

                    // eslint-disable-next-line no-var, @hapi/no-var
                    for (var i = 0; i < jobTitles.length; ++i) {
                        if (jobTitles[i].name.toLowerCase() === queryString.toLowerCase()) {
                            const matchedJob = jobTitles[i];

                            jobTitles[i] = jobTitles[0];
                            jobTitles[0] = matchedJob;
                            break;
                        }
                    }

                    if (i >= jobTitles.length || jobTitles.length === 0) {
                        jobTitles.unshift({ name: queryString });
                    }

                    // Make sure you can't add job titles twice
                    // This could happen when a new team title was created on the server, after it was already added as a chip
                    const jobNames = new Set(vm.jobTitles.map((title) => title.name.toLowerCase()));

                    return resolve(jobTitles.filter((title) => !jobNames.has(title.name.toLowerCase())));
                });
            });
        };


        vm.addJob = (job) => {

            if (job && job.name) {
                return leadsService.createTeamJobTitle(job.name);
            }
        };

        vm.getAccountString = (leadAccount) => {

            return leadAccount.id === vm.accountId ? $translate.instant('part of this account') : $translate.instant('part of') + ' ' + leadAccount.name + ' ' + $translate.instant('account');
        };


        vm.tooltipLead = null;

        vm.checkEllipsis = function ($event, lead) {
            const el = $event.currentTarget;
            // Check if the text is ellipsed
            if (el.scrollWidth > el.clientWidth) {
                vm.tooltipLead = lead.name;
            }
            else {
                vm.tooltipLead = null;
            }
        };

        vm.hideTooltip = function () {
            vm.tooltipLead = null;
        };

        vm.getLeadToolTipText = (lead) => {

            let text = lead?.name || '';

            if (!lead) {
                return '...';
            }

            if (lead.position) {
                text += ' - ' + lead.position;
            }

            // Return a replacement text for the md-tooltip initialization when the lead object isn't available yet
            return text || '...';
        };

        vm.createAndAddLeads = () => {


            if (vm.createWithoutEmail && flagsService.get('saveContactWithoutEmailWarning') === true) {
                return $mdDialog.show({
                    controller: 'CreateContactWithoutEmailDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app-ajs/components/createcontactwithoutemaildialog/createContactWithoutEmailDialog.html',
                    bindToController: true,
                    clickOutsideToClose: true,
                    multiple: true
                }).then(function () {

                    return saveLeads();
                });
            }
            else {
                return saveLeads();
            }
        };

        vm.showVirtualRepeat = () => {
            return vm.leads.doneLoading && (!!vm.leads.items && vm.leads.items.length > 0);
        };

        function saveLeads() {

            // Prep lead objects for payload
            const selectedLeads = vm.leads.items.filter((lead) => lead.selected).map((lead) => {

                const leadCopy = {
                    name: lead.name,
                    role: lead.position,
                    company: lead.company?.name,
                    link: lead.linkedin_url,
                    picture: lead.picture,
                    account: lead.account
                };

                if (lead.id) {
                    leadCopy.id = lead.id;
                }

                return leadCopy;
            });

            // Disable submit button
            vm.creating = true;

            return account.createAndAddLeads(vm.accountId, selectedLeads, { createWithoutEmail: vm.createWithoutEmail }).then((response) => {

                if (!response.data) {
                    // Something went wrong
                    vm.creating = false;
                    return utils.showErrorToast($translate.instant('Oops! Something went wrong. Please try again.'));
                }

                // Inform user that lead credits ran out
                if (response.data.success?.ran_out_of_credits_amount > 0) {
                    const addedAmount = response.data.success?.total_added_amount;
                    const totalAmount = addedAmount + response.data.success?.ran_out_of_credits_amount;
                    utils.showInfoToast($translate.instant('You\'re out of lead credits. Only {{added}} of {{total}} contacts created or updated.', { added: addedAmount, total: totalAmount }));
                    vm.creating = false;
                    return close(true);
                }

                if (response.data.success?.created_amount === 0 && response.data.success?.total_added_amount === 0) {
                    if (vm.createWithoutEmail) {
                        // This should never happen, since the only thing that might prevent contact creation or updating is if there are no emails found
                        vm.creating = false;
                        return utils.showErrorToast($translate.instant('Oops! Something went wrong. Please try again.'));
                    }
                    else {
                        utils.showInfoToast($translate.instant('No contacts created as no emails found'));
                        vm.creating = false;
                        return close(true);
                    }
                }

                const existingContacts = response.data.success?.total_added_amount - response.data.success?.created_amount;

                // Inform user if there were contacts created without email, if applicable
                // Build the created contacts message part
                const createdAmount = response.data.success?.created_amount;
                const withEmailAmount = response.data.success?.with_email_amount;
                const createdMessage = createdAmount === 0 ? '' : (createdAmount === withEmailAmount
                    ? createdAmount + ' ' + (createdAmount > 1 ? $translate.instant('contacts created with email') : $translate.instant('contact created with email'))
                    : createdAmount + ' ' + (createdAmount > 1 ? $translate.instant('contacts created ({{amount}} with email)', { amount: withEmailAmount }) : $translate.instant('contact created ({{amount}} with email)', { amount: withEmailAmount })));

                // Build the existing contacts message part if applicable
                const existingMessage = existingContacts > 0
                    ? (existingContacts > 1
                        ? $translate.instant('updated {{count}} existing contacts', { count: existingContacts })
                        : $translate.instant('updated {{count}} existing contact', { count: existingContacts }))
                    : '';

                // Combine the messages
                const toastString = createdMessage === '' ? existingMessage : createdMessage + (existingMessage === '' ? '' : ' ' + $translate.instant('and') + ' ' + existingMessage);

                utils.showSuccessToast(toastString);
                vm.creating = false;
                return close(true);
            }).catch((err) => {
                // Show toast
                vm.creating = false;
                utils.showErrorToast(err.data.message);
            }).finally(() => {
                // Refetch me in the background to always show correct amount of credits
                authentication.fetchMe({ ignoreLoadingBar: true });
            });
        }

        function close(reload) {
            // Close the tour if it's active
            if (insightsTour) {
                insightsTour.cancel();
                insightsTour = null;
            }

            return $mdDialog.hide(reload);
        }

        function showWalkthrough() {

            $timeout(function () {

                insightsTour = new Shepherd.Tour({
                    defaultStepOptions: {
                        popperOptions: {
                            // Adds an offset of 12px to the tooltip so the arrow (instead of the content) starts on the target element
                            modifiers: [{ name: 'offset', options: { offset: [0, -10] } }]
                        }
                    }
                });

                insightsTour.addStep({
                    title: $translate.instant('NEW: find leads'),
                    text: $translate.instant('Type a role or set of roles to start finding new leads at this account'),
                    attachTo: {
                        element: '#job-title-search',
                        on: 'bottom'
                    },
                    buttons: [{
                        action: insightsTour.next,
                        text: $translate.instant('GOT IT!')
                    }]
                });

                insightsTour.on('complete', function () {

                    return flagsService.set('showLeadSearchWalkthrough', false);
                });

                return insightsTour.start();
            }, 2000);
        }
    }
})();
